import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AarniSchoolsRoutingModule } from './aarni-schools-routing.module';
import { AarniSchoolOfTechnologyComponent } from './aarni-school-of-technology/aarni-school-of-technology.component';
import { AarniSchoolOfBusinessManagementAndCommerceComponent } from './aarni-school-of-business-management-and-commerce/aarni-school-of-business-management-and-commerce.component';
import { AarniSchoolOfArtAndHumanitiesComponent } from './aarni-school-of-art-and-humanities/aarni-school-of-art-and-humanities.component';
import { AarniSchoolOfBasicScienceAndBiotechnologyComponent } from './aarni-school-of-basic-science-and-biotechnology/aarni-school-of-basic-science-and-biotechnology.component';
import { AarniSchoolOfAlliedHealthScienceComponent } from './aarni-school-of-allied-health-science/aarni-school-of-allied-health-science.component';
import { AarniSchoolOfPharmacyComponent } from './aarni-school-of-pharmacy/aarni-school-of-pharmacy.component';
import { AarniSchoolOfAgricultureComponent } from './aarni-school-of-agriculture/aarni-school-of-agriculture.component';
import { AarniSchoolOfLawComponent } from './aarni-school-of-law/aarni-school-of-law.component';
import { AarniSchoolOfHotelManagementAndTourismComponent } from './aarni-school-of-hotel-management-and-tourism/aarni-school-of-hotel-management-and-tourism.component';
import { AarniSchoolOfEducationAndSportsComponent } from './aarni-school-of-education-and-sports/aarni-school-of-education-and-sports.component';
import { BtechCseSpecialisationsComponent } from './btech-cse-specialisations/btech-cse-specialisations.component';
import { BtechEeSpecialisationsComponent } from './btech-ee-specialisations/btech-ee-specialisations.component';
import { BtechEceSpecialisationsComponent } from './btech-ece-specialisations/btech-ece-specialisations.component';
import { MbaSpecialisationComponent } from './mba-specialisation/mba-specialisation.component';


@NgModule({
  declarations: [
    AarniSchoolOfTechnologyComponent,
    AarniSchoolOfBusinessManagementAndCommerceComponent,
    AarniSchoolOfArtAndHumanitiesComponent,
    AarniSchoolOfBasicScienceAndBiotechnologyComponent,
    AarniSchoolOfAlliedHealthScienceComponent,
    AarniSchoolOfPharmacyComponent,
    AarniSchoolOfAgricultureComponent,
    AarniSchoolOfLawComponent,
    AarniSchoolOfHotelManagementAndTourismComponent,
    AarniSchoolOfEducationAndSportsComponent,
    BtechCseSpecialisationsComponent,
    BtechEeSpecialisationsComponent,
    BtechEceSpecialisationsComponent,
    MbaSpecialisationComponent
  ],
  imports: [
    CommonModule,
    AarniSchoolsRoutingModule
  ]
})
export class AarniSchoolsModule { }
